import { render } from "./freeTextQuestion.vue?vue&type=template&id=21414482&scoped=true"
import script from "./freeTextQuestion.vue?vue&type=script&lang=js"
export * from "./freeTextQuestion.vue?vue&type=script&lang=js"

import "./freeTextQuestion.vue?vue&type=style&index=0&id=21414482&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21414482"]])

export default __exports__